module.exports = __webpack_public_path__ + "img/sec2.1.39bfda5d.png";